module.exports = __webpack_public_path__ + "static/img/share_moment.735a219.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bdm/share_moment.png
// module id = bFg1
// module chunks = 0